<template>
<v-layout row wrap>
  <v-flex xs12>
    <v-card>
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :total-items="totalCount"
        :headers="headers"
        :items="datas"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded" style="cursor:pointer">
            <td>{{ props.item.place ? props.item.place.name : '' }}<br>{{ props.item.charger ? props.item.charger.managementNumber : '' }}</td>
            <td>{{ props.item.checker ? props.item.checker.name : '' }}<br>{{ props.item.date }}</td>
            <td><v-icon v-if="props.item.pictureUrls && props.item.pictureUrls.length > 0">photo</v-icon></td>
            <template v-for="(checkItemKey, checkItemIndex) in checkItems">
              <td :class="$_isOkCheckItem(checkItemKey, props.item.checkItems[checkItemKey]) ? 'report_ok' : 'report_error'"
                :key="checkItemIndex">
                {{ props.item.checkItems[checkItemKey] }}
              </td>
            </template>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-card-text>
              <template v-for="(value, key) in props.item.checkItems">
                <v-chip v-if="$_isOkCheckItem(key, value)" :key="key">
                  <v-avatar>
                    <v-icon>check_circle</v-icon>
                  </v-avatar>
                  {{key}}-{{value}}
                </v-chip>
                <v-chip v-else text-color="red" :key="key">
                  <v-avatar>
                    <v-icon>flag</v-icon>
                  </v-avatar>
                  {{key}}-{{value}}
                </v-chip>
              </template>

              <v-alert v-if="props.item.momo != ''" :value="props.item.memo" type="warning">
                {{props.item.memo}}
              </v-alert>
              <br>

              <v-carousel v-if="props.item.pictureUrls.length > 0">
                <v-carousel-item v-for="(value, key) in props.item.pictureUrls"
                  :src="value" :lazy-src="value" :key="key">
                    <template v-slot:placeholder>
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                </v-carousel-item>
              </v-carousel>

              <!--
                <template v-for="(value, key) in props.item.pictureUrls">
                <v-img :src="value" :lazy-src="value" max-height="150" contain>
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </template>
              -->

              <br>{{props.item.id}}-{{props.item.location}}
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import moment from 'moment'

export default {
  name: 'HelloWorld',
  data () {
    return {
      headers: [{text: '충전소/충전기', values: 'place', sortable: false},
        {text: '보고자/보고일', values: 'checker', sortable: false},
        {text: '첨부사진', values: 'date', sortable: false}],
      datas: [],
      checkItems: [],
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      totalCount: 0, // https://stackoverflow.com/questions/46554091/firebase-firestore-collection-count, https://firebase.google.com/docs/firestore/solutions/counters
      prevStartAt: [],
      loading: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getTotalCount()
      this.$_getReports()
    },
    pagination (_new, old) {
      if (old.page === 1 && _new.page === 1) { // 최초
        this.$_getReports()
      } else if (old.page < _new.page) { // 다음
        // console.log("page = ", _new.page, this.pagination.rowsPerPage * _new.page - 1, this.datas[this.pagination.rowsPerPage * old.page - 1])
        // console.log(this.datas[this.pagination.rowsPerPage * old.page - 1])
        this.prevStartAt[old.page - 1] = this.datas[0]
        this.$_getReports(this.datas[this.pagination.rowsPerPage - 1], true)
      } else if (old.page > _new.page) { // 이전
        this.$_getReports(this.prevStartAt[_new.page - 1], false)
      }
    }
  },
  created () {
    this.$emit('title', '점검 현황')
    this.$_getTotalCount()
  },
  methods: {
    $_getTotalCount () {
      firebase.firestore().collection('counters')
        .doc('reports_daejeon')
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.exists) {
            // console.log(querySnapshot, querySnapshot.data())
            this.totalCount = querySnapshot.data().numberOfDocs
          }
        })
    },
    $_getReports (startRefDoc, isNext) {
      this.loading = true

      let query = this.$fs.collection('reports').where('group', '==', this.$store.state.session.group).orderBy('created', 'desc')

      if (startRefDoc) {
        if (isNext) {
          console.log(startRefDoc, isNext)
          query = query.startAfter(startRefDoc.created) // next 페이지는 startAfter, prev 페이지는 startAt
        } else {
          query = query.startAt(startRefDoc.created)
        }
      }

      query.limit(this.pagination.rowsPerPage)
        .get().then((querySnapshot) => {
          const checkItemSet = new Set()
          this.datas = []
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            item.date = moment(item.created.toDate().getTime()).format('YYYY-MM-DD HH:mm')
            item.pictureUrls = []

            for (var key in item.checkItems) {
              checkItemSet.add(key)
            }

            if (item.pictures && item.pictures.length > 0) {
              for (var i = 0; i < item.pictures.length; i++) {
                firebase.storage().ref(item.pictures[i]).getDownloadURL()
                  .then((result) => {
                    item.pictureUrls.push(result)
                  }).catch(error => {
                    if (error) {
                      // TODO 오류 처리
                    }
                    // console.log('error', error)
                  })
              }
            }

            this.datas.push(item)
            // console.log(moment)
          })

          this.checkItems = Array.from(checkItemSet).sort()
          // console.log('checkItems', this.checkItems)

          // TODO 기본 config 의 체크 항목 가지고 올 것
          // eslint-disable-next-line
          checkItemsFor:
          for (var i = 0; i < this.checkItems.length; i++) {
            // console.log(this.checkItems[i].text)

            for (var j = 0; j < this.headers.length; j++) {
              if (this.headers[j].text === this.checkItems[i]) {
                // eslint-disable-next-line
                continue checkItemsFor
              }
            }

            this.headers.push({text: this.checkItems[i], values: this.checkItems[i] + '_' + i, sortable: false})
          }
          // var mapAsc = new Map([...map.entries()].sort());

          this.loading = false
        }).catch(error => {
          if (error) {
            // empty
          }
          this.loading = false
        })
    },
    $_isOkCheckItem (key, value) {
      if (value === '정상' || (key === '장애물' && value === '없음')) {
        return true
      }

      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .report_ok {
    color:rgba(0,0,0,.87)
  }

  .report_error {
    color:red
  }
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportList.vue